<template>
  <b-container>
    <b-row>
      <b-col sm="5" class="mx-auto mt-5">
        <login @login="login"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import login from '@/shared/components/login'
import auth from 'b2b-common/services/auth'
import toast from 'b2b-common/mixins/toast'

export default {
  components: { login },
  mixins: [toast],
  methods: {
    login ({ client, username, password }) {
      auth.login({ client, username, password })
        .then(res => {
          if (res) {
            this.addToast({
              message: this.$gettext('Welcome to Interra Travel B2b'),
              title: this.$gettext('Login'),
              variant: 'success'
            })
            this.$router.push({ name: 'Private/Default' })
          } else {
            this.addToast({
              message: this.$gettext('Please check the data entered in the form. Client code, username or password are invalid.'),
              title: this.$gettext('Invalid login'),
              variant: 'danger'
            })
          }
        }).catch(() => {
          this.addToast({
            message: this.$gettext('Invalid form'),
            title: this.$gettext('Invalid login'),
            variant: 'danger'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
